import {Globe} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const LanguageIcon = createLucideIcon(Globe, 'LanguageIcon');
